import { render, staticRenderFns } from "./TwoFactorCard.vue?vue&type=template&id=0e029847"
import script from "./TwoFactorCard.vue?vue&type=script&lang=js"
export * from "./TwoFactorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports